webpackJsonp([18],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  ERP_PORT: 'https://oss.onead.com.tw' || 'http://localhost:4000',
  MOAI_PORT: 'https://creative.onead.com.tw' || 'http://localhost:5000'
};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = vendor_library;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(8);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(13);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(14);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_video__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_search__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_advertiser__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_category__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dashboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_count__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_todos__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_list__ = __webpack_require__(74);
















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__root__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__root__["b" /* getters */],
  actions: __WEBPACK_IMPORTED_MODULE_2__root__["c" /* actions */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__root__["d" /* mutations */],

  modules: {
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_5__modules_search__["a" /* default */],
    advertiser: __WEBPACK_IMPORTED_MODULE_6__modules_advertiser__["a" /* default */],
    category: __WEBPACK_IMPORTED_MODULE_7__modules_category__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_4__modules_video__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_8__modules_dashboard__["a" /* default */],

    count: __WEBPACK_IMPORTED_MODULE_9__modules_count__["a" /* default */],
    todos: __WEBPACK_IMPORTED_MODULE_10__modules_todos__["a" /* default */],
    list: __WEBPACK_IMPORTED_MODULE_11__modules_list__["a" /* default */]
  },

  strict: true
}));

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadingStatusShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadingStatusHide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleMobileMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return togglePopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return popupType; });
var loadingStatusShow = 'loadingStatusShow';
var loadingStatusHide = 'loadingStatusHide';
var toggleMobileMenu = 'toggleMobileMenu';
var togglePopup = 'togglePopup';
var popupType = 'popupType';

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(139);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  var position = {};

  if (to.hash) {
    position.selector = to.hash;
  }
  if (to.matched.some(function (m) {
    return m.meta.scrollToTop;
  })) {
    position.x = 0;
    position.y = 0;
  }
  return position;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: '/404',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 144));
    }
  }, {
    path: '/chart',
    name: 'chart',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 145));
    }
  }, {
    path: '/resetpassword',
    name: 'Resetpassword',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 152));
    }
  }, {
    path: '/updatepassword',
    name: 'Updatepassword',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 153));
    },
    meta: { requiresAuth: true }
  }, {
    path: '/check_account_status',
    name: 'CheckAccountStatus',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 151));
    }
  }, {
    path: '/vuex',
    name: 'Vuex',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 147));
    }
  }, {
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 146));
    },
    children: [{
      path: '',
      name: 'Home',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 149));
      }
    }, {
      path: '/trend',
      name: 'Trend',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 155));
      },
      meta: { scrollToTop: true }
    }, {
      path: '/trend/:id',
      name: 'TrendDetail',
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 156));
      },
      meta: { scrollToTop: true }
    }, {
      path: '/search',
      name: 'Search',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 154));
      }
    }, {
      path: '/list/:type/:page',
      name: 'List',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 150));
      }
    }, {
      path: '/advertisers/:advertiser_id/videos/:id',
      name: 'Detail',
      component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 148));
      }
    }, {
      path: '/brand',
      name: 'Brand',
      component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 142));
      },
      meta: { requiresAuth: true }
    }, {
      path: '/category/:id',
      name: 'Category',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 143));
      },
      meta: { requiresAuth: true }
    }, {
      path: '/userbackend',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 157));
      },
      meta: { requiresAuth: true },
      children: [{
        path: '',
        name: 'userIndexBackend',
        component: function component() {
          return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 158));
        }
      }]
    }]
  }]
}));

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutations_type__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(21);







__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (config.method === 'post' && config.url.indexOf('token') === -1) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_2__store_mutations_type__["a" /* loadingStatusShow */]);
  }

  return config;
}, function (error) {
  console.log('網路異常');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (res) {
  if (res.status !== 200) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  }

  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_2__store_mutations_type__["b" /* loadingStatusHide */]);

  return res;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_2__store_mutations_type__["b" /* loadingStatusHide */]);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mycomponent */
/* unused harmony export mycomponent2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var mycomponent = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('mycomponentone', {
  template: '<div>A custom component - 1!</div>'
});

var mycomponent2 = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('mycomponentwo', {
  template: '<div>A custom component - 2!</div>'
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export directiveFocusOne */
/* unused harmony export directiveFocusTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var directiveFocusOne = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

var directiveFocusTwo = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('focus2', {
  inserted: function inserted(el) {
    el.focus();
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(21);





var auth = {
  isLoginIn: function isLoginIn() {
    return !!localStorage.getItem('access_token');
  },
  checkLoginOverTime: function checkLoginOverTime() {
    var twoHours = 60 * 60 * 2;
    var nowTime = Math.round(new Date().getTime() / 1000);
    var loginInTime = Math.round(+localStorage.getItem('expire_time') / 1000 + twoHours);

    var loginStatus = nowTime > loginInTime ? (localStorage.removeItem('access_token'), __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('userService/user_login_out'), loginInTime !== twoHours ? alert('系統已登出') : '') : '';

    return loginStatus;
  }
};

__WEBPACK_IMPORTED_MODULE_0_router__["a" /* default */].beforeEach(function (to, from, next) {

  auth.checkLoginOverTime();

  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {

    if (!auth.isLoginIn()) {
      next({
        path: '/'
      });
    } else {
      next();
    }
  } else {
    if (to.path === '/login' && auth.loggedIn()) {
      next({ path: '/' });
    }
    next();
  }
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(134),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(11);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(9);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inViewport */
/* harmony export (immutable) */ __webpack_exports__["g"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["d"] = isBodyFixed;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = addUrlQueryValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = formatMMSS;
/* harmony export (immutable) */ __webpack_exports__["e"] = showPages;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEmailName;
function inViewport(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      right = _element$getBoundingC.right,
      bottom = _element$getBoundingC.bottom,
      left = _element$getBoundingC.left;

  return bottom > offset && right > offset && window.innerWidth - left > offset && window.innerHeight - top > offset;
}

function throttle(fn, delay, atleast) {
  var timer = null;
  var previous = null;

  return function () {
    var now = +new Date();

    if (!previous) previous = now;
    if (atleast && now - previous > atleast) {
      fn();
      previous = now;
      clearTimeout(timer);
    } else {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn();
        previous = null;
      }, delay);
    }
  };
}

function isBodyFixed() {
  var body = document.body;

  if (body.classList.contains('overflow_hidden') === true) {
    body.classList.remove('overflow_hidden');
  } else {
    body.classList.add('overflow_hidden');
  }
}

function formatNumber(val) {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function addUrlQueryValue(value) {
  if (history.pushState) {
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + value;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

function formatMMSS(secs) {
  var secNum = parseInt(secs, 10);
  var hours = Math.floor(secNum / 3600) % 24;
  var minutes = Math.floor(secNum / 60) % 60;
  var seconds = secNum % 60;

  return [hours, minutes, seconds].map(function (v) {
    return v < 10 ? '0' + v : v;
  }).filter(function (v, i) {
    return v !== '00' || i > 0;
  }).join(':');
}

function showPages(pageNum, total) {
  var page = +pageNum;

  var str = isNaN(page) ? page : page.toString();

  for (var i = 1; i <= 3; i++) {
    if (page - i > 1) {
      str = page - i + ' ' + str;
    }
    if (page + i < total) {
      str = str + ' ' + (page + i);
    }
  }

  if (page - 4 > 1) {
    str = 'ellipsis ' + str;
  }

  if (page > 1) {
    str = '1 ' + str;
  }

  if (page + 4 < total) {
    str = str + ' ellipsis';
  }

  if (page < total) {
    str = str + ' ' + total;
  }
  return str;
}

function getEmailName(email) {
  var name = '';
  if (typeof email === 'string' && email.indexOf('@') !== -1) {
    name = email.split('@')[0];
  }
  return name;
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(10);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_highcharts__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_highstock__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_highstock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highcharts_highstock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_modules_map__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_modules_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highcharts_modules_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts_more__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_highcharts_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_auth__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_global_components__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_focus__ = __webpack_require__(51);

















__WEBPACK_IMPORTED_MODULE_3_highcharts_highstock___default.a.setOptions({
  credits: {
    enabled: false
  },
  yAxis: {
    title: { text: null },
    opposite: false
  }
});

__WEBPACK_IMPORTED_MODULE_4_highcharts_modules_map___default()(__WEBPACK_IMPORTED_MODULE_3_highcharts_highstock___default.a);
__WEBPACK_IMPORTED_MODULE_5_highcharts_more___default()(__WEBPACK_IMPORTED_MODULE_3_highcharts_highstock___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_highcharts___default.a, { Highcharts: __WEBPACK_IMPORTED_MODULE_3_highcharts_highstock___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_meta___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_6__App___default.a
  },
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]
});

console.log('%c ★ Brand Master ★', 'font-size: 20px; background-color: #e89022; color: #ffffff; padding: 0 20px;');

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getAllAdvertisers: function getAllAdvertisers() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/advertisers').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        _data: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_config_http__ = __webpack_require__(34);



function getAccessToken() {
  return localStorage.getItem('access_token');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCategories: function getAllCategories() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_config_http__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__env___default.a.ERP_PORT + '/api/v1/pre_campaigns/categories').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        _data: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getCategoryVideoList: function getCategoryVideoList(pageData) {

    var url = '';

    var id = pageData.id,
        pageId = pageData.pageId;


    if (pageId) {
      url = __WEBPACK_IMPORTED_MODULE_0__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos?category_id=' + id + '&page=' + pageId;
    } else {
      url = __WEBPACK_IMPORTED_MODULE_0__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos?category_id=' + id;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_config_http__["a" /* default */])(url, {
      params: {
        access_token: getAccessToken()
      }
    }).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          total_pages = resultData.total_pages,
          data = resultData.data;


      return {
        data: data,
        _success: success,
        _message: message,
        total_pages: total_pages
      };
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);



function getAccessToken() {
  return localStorage.getItem('access_token');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getUserDashboardVideos: function getUserDashboardVideos(agencyId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos?per_page=500&type=advertiser&client_id=' + agencyId, {
      params: {
        access_token: getAccessToken()
      }
    }).then(function (response) {
      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        _data: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getUserDashboardVideosDetail: function getUserDashboardVideosDetail(videoData) {
    var videoId = videoData.videoId,
        agencyId = videoData.agencyId;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + videoId + '?client_id=' + agencyId, {
      params: {
        access_token: getAccessToken()
      }
    }).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        detailData: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getDashboardDesktopSummary: function getDashboardDesktopSummary(urlData) {
    var videoId = urlData.videoId,
        type = urlData.type,
        clientId = urlData.clientId;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + videoId + '/summary?client_id=' + clientId + '&type=' + type + '&device=desktop', {
      params: {
        access_token: getAccessToken()
      }
    }).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        data: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getDashboardMobileSummary: function getDashboardMobileSummary(urlData) {
    var videoId = urlData.videoId,
        type = urlData.type,
        clientId = urlData.clientId;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + videoId + '/summary?client_id=' + clientId + '&type=' + type + '&device=mobile', {
      params: {
        access_token: getAccessToken()
      }
    }).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          data = resultData.data;


      return {
        data: data,
        _success: success,
        _message: message
      };
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  demo: function demo() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()('http://www.monoame.com/awi_class/api/command.php?type=get&name=itemdata').then(function (response) {
      var data = response.data;


      return data;
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getSearchVideo: function getSearchVideo(query) {
    var keyword = query.keyword,
        page = query.page;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos?page=' + page + '&keyword=' + keyword).then(function (response) {

      var resultData = response.data;

      var data = resultData.data,
          total_pages = resultData.total_pages;


      return {
        data: data,
        total_pages: total_pages
      };
    }).catch(function (error) {
      return console.log(error);
    });
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_http__ = __webpack_require__(34);




function getAccessToken() {
  return localStorage.getItem('access_token');
}

function getUserType(kind) {
  var userType = localStorage.getItem('type');

  switch (userType) {
    case 'Account':
      return kind === 'api_url' ? 'accounts' : 'account';
    case 'User':
      return kind === 'api_url' ? 'users' : 'user';
    default:
      return '';
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  signInUser: function signInUser(userData) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_http__["a" /* default */])({
      method: 'post',
      url: __WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/sign_in.json',
      data: {
        user: {
          email: userData.email,
          password: userData.password
        }
      },
      headers: {
        remoteSystem: 'OBM'
      }
    });
  },
  forgetPasswordUser: function forgetPasswordUser(email) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_http__["a" /* default */])({
      method: 'post',
      url: __WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/users/password.json',
      data: {
        user: {
          email: email
        }
      },
      headers: {
        remoteSystem: 'OBM'
      }
    });
  },
  resetPasswordUser: function resetPasswordUser(newpw, confirmpw, token) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_http__["a" /* default */])({
      method: 'put',
      url: __WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/accounts/password.json',
      data: {
        account: {
          password: newpw,
          password_confirmation: confirmpw,
          reset_password_token: token
        }
      },
      headers: {
        remoteSystem: 'OBM'
      }
    });
  },
  updatePasswordUser: function updatePasswordUser(oldpw, confirmpw, newpw, token) {
    var _data;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_http__["a" /* default */])({
      method: 'put',
      url: __WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/' + getUserType('api_url') + '.json',
      params: {
        access_token: getAccessToken()
      },
      data: (_data = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data, getUserType(), {
        current_password: oldpw,
        password: newpw,
        password_confirmation: confirmpw
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data, 'access_token', token), _data),
      headers: {
        remoteSystem: 'OBM'
      }
    });
  },
  checkAccount: function checkAccount(verificationCode) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_http__["a" /* default */])({
      method: 'post',
      url: __WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/reverify?verification_code=' + verificationCode,
      headers: {
        remoteSystem: 'OBM'
      }
    });
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getNewSlideVideoList: function getNewSlideVideoList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos?per_page=60').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          data = resultData.data;


      return {
        data: data,
        success: success,
        message: message,
        next_page: next_page
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getVideoViewList: function getVideoViewList(num) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos?sorting=view&page=' + num).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          total_pages = resultData.total_pages,
          data = resultData.data;


      return {
        data: data,
        success: success,
        message: message,
        next_page: next_page,
        total_pages: total_pages
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getViewSlideVideoList: function getViewSlideVideoList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos?per_page=60&sorting=view').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          data = resultData.data;


      return {
        data: data,
        success: success,
        message: message,
        next_page: next_page
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getBannerVideoList: function getBannerVideoList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos/slider').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          data = resultData.data;


      return {
        _data: data,
        _success: success,
        _message: message,
        _nextPage: next_page
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getVideoList: function getVideoList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos').then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          data = resultData.data;


      return {
        _data: data,
        _success: success,
        _message: message,
        _nextPage: next_page
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getMoreVideoList: function getMoreVideoList(num) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/videos?page=' + num).then(function (response) {

      var resultData = response.data;

      var success = resultData.success,
          message = resultData.message,
          next_page = resultData.next_page,
          total_pages = resultData.total_pages,
          data = resultData.data;


      return {
        data: data,
        _success: success,
        _message: message,
        _nextPage: next_page,
        total_pages: total_pages
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getAdvertisersList: function getAdvertisersList(advertiserId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/advertisers/' + advertiserId + '/videos').then(function (response) {

      var resultData = response.data;

      var data = resultData.data;


      return {
        _data: data
      };
    }).catch(function (error) {
      return console.log(error);
    });
  },
  getAdvertisersVideo: function getAdvertisersVideo(advertiserId, id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(__WEBPACK_IMPORTED_MODULE_1__env___default.a.ERP_PORT + '/api/v1/bm/advertisers/' + advertiserId + '/videos/' + id).then(function (response) {

      var resultData = response.data;

      var data = resultData.data;


      return {
        _data: data
      };
    }).catch(function () {
      var origin = window.location.origin;


      window.location = origin + '/';
    });
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_advertiser__ = __webpack_require__(63);



var types = {
  GET_ALL_ADVERTISERS: 'advertiserService/getAllAdvertisers'
};

var state = {
  allAdvertisers: []
};

var getters = {
  getAllAdvertisers: function getAllAdvertisers(s) {
    return s.allAdvertisers;
  }
};

var actions = {
  actionGetAllAdvertisers: function actionGetAllAdvertisers(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_advertiser__["a" /* default */].getAllAdvertisers().then(function (res) {
      var _data = res._data;


      commit(types.GET_ALL_ADVERTISERS, _data);
    }).catch(function () {});
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, types.GET_ALL_ADVERTISERS, function (s, d) {
  s.allAdvertisers = d;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_category__ = __webpack_require__(64);


var _mutations;



var types = {
  GET_ALL_CATEGORIES: 'categoryService/getAllCategories',
  GET_CATEGORY_NAME: 'categoryService/getAllCategoryName',
  GET_CATEGORY_VIDEO_TOTAL: 'categoryService/getAllCategoryTotal',
  GET_CATEGORY_VIDEO_LIST: 'categoryService/getCategoryVideoList'
};

var state = {
  allCategories: [],
  currentCategoryName: '',
  categoryVideoTotal: 0,
  categoryVideoList: []
};

var getters = {
  getAllCategories: function getAllCategories(s) {
    return s.allCategories;
  },
  getCategoryVideoTotal: function getCategoryVideoTotal(s) {
    return s.categoryVideoTotal;
  },
  getCurrentCategoryName: function getCurrentCategoryName(s) {
    return s.currentCategoryName;
  },

  getCategoryVideoList: function getCategoryVideoList(s) {
    return s.categoryVideoList;
  }
};

var actions = {
  actionGetAllCategories: function actionGetAllCategories(_ref, id) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_category__["a" /* default */].getAllCategories().then(function (res) {
      var _data = res._data;


      switch (id) {
        case 'all':
          commit(types.GET_ALL_CATEGORIES, _data);
          break;

        default:
          {
            var d = _data.filter(function (c) {
              return c.id === id;
            });

            var name = d[0].name;


            commit(types.GET_CATEGORY_NAME, name);
            commit(types.GET_ALL_CATEGORIES, _data);
          }
      }
    }).catch(function () {});
  },
  actionGetCategoryVideoList: function actionGetCategoryVideoList(_ref2, pageData) {
    var commit = _ref2.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_category__["a" /* default */].getCategoryVideoList(pageData).then(function (res) {
      var data = res.data,
          total_pages = res.total_pages;


      commit(types.GET_CATEGORY_VIDEO_TOTAL, total_pages);
      commit(types.GET_CATEGORY_VIDEO_LIST, data);
    }).catch(function () {});
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_CATEGORY_NAME, function (s, name) {
  s.currentCategoryName = name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_ALL_CATEGORIES, function (s, data) {
  s.allCategories = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_CATEGORY_VIDEO_TOTAL, function (s, d) {
  s.categoryVideoTotal = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_CATEGORY_VIDEO_LIST, function (s, d) {
  s.categoryVideoList = d;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mutations;

var types = {
  INCREASE: 'count/INCREASE',
  DECREASE: 'count/DECREASE',
  COUNT_RESET: 'count/COUNT_RESET'
};

var state = {
  count: 0
};

var getters = {
  getCount: function getCount(s) {
    return s.count;
  }
};

var actions = {
  actionIncrease: function actionIncrease(_ref, num) {
    var commit = _ref.commit;

    commit(types.INCREASE, num);
  },
  actionDecrease: function actionDecrease(_ref2, num) {
    var commit = _ref2.commit;

    commit(types.DECREASE, num);
  },
  actionCountReset: function actionCountReset(_ref3) {
    var commit = _ref3.commit;

    commit(types.COUNT_RESET);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.INCREASE, function (s, num) {
  s.count += num;
  console.log('newINCREASE', num, 's?', s.count);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.DECREASE, function (s, num) {
  s.count -= num;
  console.log('newDECREASE', num, 's?', s.count);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.COUNT_RESET, function (s) {
  s.count = 0;
  console.log('newCOUNT_RESET - s?', s.count);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dashboard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_env__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_env__);


var _mutations;




var types = {
  ALL_CAMPAIGN_URLS: 'dashboardService/allCampaignUrls',
  CLEAR_ALL_CAMPAIGN_URLS: 'dashboardService/clearAllCampaignUrls',

  CHANGE_CHARTS_URLS: 'dashboardService/changeChartsUrls',
  CLEAR_ALL_SUMMARY: 'dashboardService/clearAllSummary',

  GET_CAMPAIGN_SUMMARY: 'dashboardService/getCampaignSummary',
  GET_DESKTOP_SUMMARY: 'dashboardService/getDesktopSummary',
  GET_MOBILE_SUMMARY: 'dashboardService/getMobileSummary',

  GET_ALL_DASHBOARD_VIDEOS: 'dashboardService/getAllDashboardVideos',
  GET_DASHBOARD_VIDEO_DETAIL: 'dashboardService/getDashboardVideoDetail'
};

var state = {
  allChartUrls: null,
  campaignUrls: null,
  allDashboardVideos: [],

  campaignSummary: null,
  desktopSummary: null,
  mobileSummary: null,

  dashboardVideoDetail: null
};

var getters = {
  getCampaignSummary: function getCampaignSummary(s) {
    return s.campaignSummary;
  },
  getDesktopSummary: function getDesktopSummary(s) {
    return s.desktopSummary;
  },
  getMobileSummary: function getMobileSummary(s) {
    return s.mobileSummary;
  },

  getAllChartUrls: function getAllChartUrls(s) {
    return s.allChartUrls;
  },
  getCampaignUrls: function getCampaignUrls(s) {
    return s.campaignUrls;
  },

  getAllDashboardVideosWithAgency: function getAllDashboardVideosWithAgency(s) {
    return s.allDashboardVideos.filter(function (v) {
      return v.agency.id !== null;
    });
  },
  getAllDashboardVideos: function getAllDashboardVideos(s) {
    return s.allDashboardVideos;
  },
  getDashboardVideoDetail: function getDashboardVideoDetail(s) {
    return s.dashboardVideoDetail;
  }
};

var actions = {
  actionClearCampaignUrls: function actionClearCampaignUrls(_ref) {
    var commit = _ref.commit;

    commit(types.CLEAR_ALL_CAMPAIGN_URLS);
  },
  actionClearAllSummary: function actionClearAllSummary(_ref2) {
    var commit = _ref2.commit;

    commit(types.CLEAR_ALL_SUMMARY);
  },
  actionGetAllDashboardVideos: function actionGetAllDashboardVideos(_ref3, agencyId) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1__services_dashboard__["a" /* default */].getUserDashboardVideos(agencyId).then(function (res) {
      var _data = res._data;


      commit(types.GET_ALL_DASHBOARD_VIDEOS, _data);

      if (_data.length !== 0) {
        var videoId = _data[0].video_id;

        commit(types.CHANGE_CHARTS_URLS, videoId);

        __WEBPACK_IMPORTED_MODULE_1__services_dashboard__["a" /* default */].getUserDashboardVideosDetail({
          videoId: videoId,
          agencyId: agencyId
        }).then(function (result) {
          var detailData = result.detailData;


          commit(types.GET_DASHBOARD_VIDEO_DETAIL, detailData);
        }).catch(function () {});
      } else {
        commit(types.GET_DASHBOARD_VIDEO_DETAIL, null);
      }
    }).catch(function () {});
  },
  actionGetDashboardVideoDetail: function actionGetDashboardVideoDetail(_ref4, data) {
    var commit = _ref4.commit;
    var videoId = data.videoId;


    __WEBPACK_IMPORTED_MODULE_1__services_dashboard__["a" /* default */].getUserDashboardVideosDetail(data).then(function (res) {
      var detailData = res.detailData;


      commit(types.GET_DASHBOARD_VIDEO_DETAIL, detailData);
      commit(types.CHANGE_CHARTS_URLS, videoId);
    }).catch(function () {});
  },
  actionGetDesktopSummary: function actionGetDesktopSummary(_ref5, urlData) {
    var commit = _ref5.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_dashboard__["a" /* default */].getDashboardDesktopSummary(urlData).then(function (res) {
      var data = res.data;


      commit(types.GET_DESKTOP_SUMMARY, data);
    }).catch(function () {});
  },
  actionGetMobileSummary: function actionGetMobileSummary(_ref6, urlData) {
    var commit = _ref6.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_dashboard__["a" /* default */].getDashboardMobileSummary(urlData).then(function (res) {
      var data = res.data;


      commit(types.GET_MOBILE_SUMMARY, data);
    }).catch(function () {});
  },
  actionGetCampaignUrls: function actionGetCampaignUrls(_ref7, urlData) {
    var commit = _ref7.commit;

    commit(types.ALL_CAMPAIGN_URLS, urlData);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.ALL_CAMPAIGN_URLS, function (s, urlData) {
  var id = urlData.id,
      type = urlData.type,
      clientId = urlData.clientId;


  switch (type) {
    case 'speed':
      s.campaignUrls = {
        dailyViewMultipleSeriesData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_view_multiple_series?type=' + type + '&client_id=' + clientId },
        dailyImpressionMultipleSeriesData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_impression_multiple_series?type=' + type + '&client_id=' + clientId },
        dailyQuartileMultipleRangeAndLineData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_quartile_basic_area?type=' + type + '&client_id=' + clientId },
        dailyReachArea: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_reach_area?type=' + type + '&client_id=' + clientId },
        deviceDonutChartData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/device_donut_chart?type=' + type + '&client_id=' + clientId },
        interestPieChartData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/interest_pie_chart?type=' + type + '&client_id=' + clientId },
        demographicsPieChartData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/demographics_pie_chart?type=' + type + '&client_id=' + clientId },
        dailyInteractionMultipleSeriesData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_interaction_multiple_series?type=' + type + '&client_id=' + clientId },
        genderPieChartData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/gender_pie_chart?type=' + type + '&client_id=' + clientId }
      };
      break;

    case 'direct':
      s.campaignUrls = {
        dailyQuartileMultipleRangeAndLineData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_quartile_basic_area?type=' + type + '&client_id=' + clientId },

        dailyReachArea: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_reach_area?type=' + type + '&client_id=' + clientId },

        deviceDonutChartData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/device_donut_chart?type=' + type + '&client_id=' + clientId },

        dailySovMultipleSeriesData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/videos/' + id + '/graphs/daily_sov_multiple_series?type=' + type + '&client_id=' + clientId }
      };
      break;
    default:
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CHANGE_CHARTS_URLS, function (s) {

  s.allChartUrls = {
    hourReachSplineData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/graphs/hourly_device_reach_spline' },
    dailyReachSplineData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/graphs/daily_device_reach_spline' },
    quartileViewRateData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/graphs/quartile_view_rate_table' },
    interactionRateBasicColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/graphs/interaction_rate_basic_column' },

    deviceReachDonutChartDataZero: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/0/graphs/device_reach_donut_chart' },
    deviceReachDonutChartDataOne: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/1/graphs/device_reach_donut_chart' },
    deviceReachDonutChartDataTwo: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/2/graphs/device_reach_donut_chart' },
    deviceReachDonutChartDataThree: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/3/graphs/device_reach_donut_chart' },

    interestReachBasicColumnDataZero: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/0/graphs/interest_reach_basic_column' },
    interestReachBasicColumnDataOne: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/1/graphs/interest_reach_basic_column' },
    interestReachBasicColumnDataTwo: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/2/graphs/interest_reach_basic_column' },
    interestReachBasicColumnDataThree: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/media/3/graphs/interest_reach_basic_column' },

    lastMonthInterestReachBasicColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_interest_reach_basic_column' },
    lastMonthDeviceReachBasicColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_device_reach_basic_column' },

    hourlyReachSplineAudienceData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/hourly_reach_spline' },
    dailyReachSplineAudienceData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/daily_reach_spline' },

    lastMonthInterestQuartileViewRateStackedColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_interest_quartile_view_rate_fixed_placement_columns' },
    lastMonthDeviceQuartileViewRateStackedColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_device_quartile_view_rate_fixed_placement_columns' },

    lastMonthInterestInteractionRateBasicColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_interest_interaction_rate_basic_column' },
    lastMonthDeviceInteractionRateBasicColumnData: { url: __WEBPACK_IMPORTED_MODULE_2__services_env___default.a.ERP_PORT + '/api/v1/bm/dashboard/audience/graphs/last_month_device_interaction_rate_basic_column' }
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_ALL_DASHBOARD_VIDEOS, function (s, d) {
  s.allDashboardVideos = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_CAMPAIGN_SUMMARY, function (s, d) {
  s.campaignSummary = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_DESKTOP_SUMMARY, function (s, d) {
  s.desktopSummary = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_MOBILE_SUMMARY, function (s, d) {
  s.mobileSummary = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_DASHBOARD_VIDEO_DETAIL, function (s, d) {
  s.dashboardVideoDetail = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CLEAR_ALL_SUMMARY, function (s) {
  s.desktopSummary = null;
  s.mobileSummary = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.CLEAR_ALL_CAMPAIGN_URLS, function (s) {
  s.campaignUrls = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_demo__ = __webpack_require__(66);



var types = {
  INITLIST: 'list/initList'
};

var state = {
  list: []
};

var getters = {
  initList: function initList(s) {
    return s.list;
  }
};

var actions = {
  actionInitList: function actionInitList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_demo__["a" /* default */].demo().then(function (res) {
      commit(types.INITLIST, res);
    }).catch(function () {});
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, types.INITLIST, function (s, r) {
  s.list = r;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_search__ = __webpack_require__(67);


var _mutations;



var types = {
  GET_SEARCH_KEYWORD: 'searchService/getSearchKeyword',
  GET_SEARCH_KEYWORD_TOTAL: 'searchService/getSearchKeywordTotal'
};

var state = {
  videoSearchData: [],
  videoSearchTotal: 0
};

var getters = {
  getSearchVideo: function getSearchVideo(s) {
    return s.videoSearchData;
  },
  getSearchVideoTotal: function getSearchVideoTotal(s) {
    return s.videoSearchTotal;
  }
};

var actions = {
  searchKeyword: function searchKeyword(_ref, query) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_search__["a" /* default */].getSearchVideo(query).then(function (res) {
      var data = res.data,
          total_pages = res.total_pages;


      commit(types.GET_SEARCH_KEYWORD_TOTAL, total_pages);
      commit(types.GET_SEARCH_KEYWORD, data);
    }).catch(function () {});
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_SEARCH_KEYWORD, function (s, d) {
  s.videoSearchData = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_SEARCH_KEYWORD_TOTAL, function (s, d) {
  s.videoSearchTotal = d;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mutations;

var types = {
  INIT_TODO: 'todos/INIT_TODO',
  ADD_TODO: 'todos/ADD_TODO',
  TOGGLE_TODO: 'todos/TOGGLE_TODO',
  DELETE_TODO: 'todos/DELETE_TODO',
  UPDATE_TODO: 'todos/UPDATE_TODO'
};

var state = {
  list: [],
  todos: []
};

var getters = {
  getDone: function getDone(s) {
    return s.todos.filter(function (items) {
      return items.done;
    });
  },
  getTodo: function getTodo(s) {
    return s.todos.filter(function (items) {
      return !items.done;
    });
  }
};

var actions = {
  initTodo: function initTodo(_ref) {
    var commit = _ref.commit;


    setTimeout(function () {
      var ajaxResultTodos = [{
        key: 0,
        content: 'Vuejs 2.0',
        done: true
      }, {
        key: 1,
        content: 'Vuex 2.0',
        done: false
      }, {
        key: 2,
        content: 'Vue-route 2.0',
        done: false
      }, {
        key: 3,
        content: 'Vue-resource 2.0',
        done: true
      }, {
        key: 4,
        content: 'webpack',
        done: false
      }];

      commit(types.INIT_TODO, ajaxResultTodos);
    }, 5000);
  },
  addTodo: function addTodo(_ref2, newTodo) {
    var commit = _ref2.commit;

    commit(types.ADD_TODO, newTodo);
  },
  toggleTodo: function toggleTodo(_ref3, key) {
    var commit = _ref3.commit;

    commit(types.TOGGLE_TODO, key);
  },
  deleteTodo: function deleteTodo(_ref4, key) {
    var commit = _ref4.commit;

    commit(types.DELETE_TODO, key);
  },
  updateTodo: function updateTodo(_ref5, obj) {
    var commit = _ref5.commit;

    commit(types.UPDATE_TODO, obj);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.INIT_TODO, function (s, t) {
  s.todos = t;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.ADD_TODO, function (s, newTodo) {
  var todoKey = s.todos.length;

  s.todos.push({
    key: todoKey,
    content: newTodo,
    done: false
  });

  todoKey += 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.TOGGLE_TODO, function (s, key) {
  s.todos.forEach(function (t) {
    if (t.key === key) {
      t.done = !t.done;
      console.log('TOGGLE_TODO: ', t.content, 'done?', t.done);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.DELETE_TODO, function (s, key) {
  s.todos = s.todos.filter(function (t) {
    return t.key !== key;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.UPDATE_TODO, function (s, obj) {
  console.log('obj', obj);
  s.todos.forEach(function (t) {
    if (t.key === obj.key) {
      console.log('UPDATE_TODO:', t.content, ' to →', obj.change);
      t.content = obj.change;
    }
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_type__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__help_index__ = __webpack_require__(59);



var _mutations;







function setStorage(key, value) {
  if (window.localStorage) localStorage.setItem(key, value);
}

function removeStorage(key) {
  if (window.localStorage) localStorage.removeItem(key);
}

var types = {
  USER_STATUS_RESET: 'userService/user_status_reset',

  USER_LOGIN_OUT: 'userService/user_login_out',
  USER_LOGIN_IN: 'userService/user_login_in',
  USER_LOGIN_IN_ERROR: 'userService/user_login_in_error',

  USER_FORGETPASSWORD_STATUS: 'userService/user_forgetpassword_status',

  USER_RESETPASSWORD_STATUS: 'userService/user_resetpassword_status',
  USER_RESETPASSWORD_MESSAGE: 'userService/user_resetpassword_message',

  USER_UPDATEPASSWORD_STATUS: 'userService/user_updatepassword_status',
  USER_UPDATEPASSWORD_MESSAGE: 'userService/user_updatepassword_message',

  USER_CHECK_ACCOUNT_STATUS: 'userService/user_check_account_status',
  USER_CHECK_ACCOUNT_MESSAGE: 'userService/user_check_account_message'
};

var state = {
  resetPasswordStatus: '',
  resetPasswordMsg: '',

  updatePasswordStatus: '',
  updatePasswordMsg: '',

  forgetPasswordStatus: '',

  checkUserAccountStatus: '',
  checkUserAccountMsg: '',

  userLoginStatus: false,
  userLoginError: false
};

var getters = {
  getUserLoginStatus: function getUserLoginStatus(s) {
    return s.userLoginStatus;
  },
  getUserLoginError: function getUserLoginError(s) {
    return s.userLoginError;
  },

  getForgetpasswordStatus: function getForgetpasswordStatus(s) {
    return s.forgetPasswordStatus;
  },

  getUpdatepasswordStatus: function getUpdatepasswordStatus(s) {
    return s.updatePasswordStatus;
  },
  getUpdatepasswordMsg: function getUpdatepasswordMsg(s) {
    return s.updatePasswordMsg;
  },

  getResetpasswordStatus: function getResetpasswordStatus(s) {
    return s.resetPasswordStatus;
  },
  getResetpasswordMsg: function getResetpasswordMsg(s) {
    return s.resetPasswordMsg;
  },

  getCheckUserAccountStatus: function getCheckUserAccountStatus(s) {
    return s.checkUserAccountStatus;
  },
  getCheckUserAccountMsg: function getCheckUserAccountMsg(s) {
    return s.checkUserAccountMsg;
  }
};

var actions = {
  resetUserStatus: function resetUserStatus(_ref) {
    var commit = _ref.commit;

    commit(types.USER_STATUS_RESET);
  },
  actionUserLoginIn: function actionUserLoginIn(_ref2) {
    var commit = _ref2.commit;

    commit(types.USER_LOGIN_IN);
  },
  actionUserLoginOut: function actionUserLoginOut(_ref3) {
    var commit = _ref3.commit;

    commit(types.USER_LOGIN_OUT);
  },
  actionLoginIn: function actionLoginIn(_ref4, userData) {
    var commit = _ref4.commit;
    var router = userData.router;


    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].signInUser(userData).then(function (res) {
      var _res$data$data = res.data.data,
          id = _res$data$data.id,
          email = _res$data$data.email,
          type = _res$data$data.type,
          parties = _res$data$data.parties,
          tokenInfo = _res$data$data.token_info,
          lowActivity = _res$data$data.low_activity;

      if (lowActivity) {

        router.push('/check_account_status');
      } else {
        var access_token = tokenInfo.access_token;


        setStorage('access_token', access_token);
        setStorage('expire_time', new Date().getTime());
        setStorage('username', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__help_index__["a" /* getEmailName */])(email));
        setStorage('id', id);
        setStorage('type', type);
        setStorage('parties', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(parties));

        commit(types.USER_LOGIN_IN);

        router.push('/');
      }

      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["c" /* togglePopup */]);
    }).catch(function () {
      return commit(types.USER_LOGIN_IN_ERROR);
    });
  },
  actionForgetPassword: function actionForgetPassword(_ref5, viewData) {
    var commit = _ref5.commit;
    var router = viewData.router,
        email = viewData.email;


    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].forgetPasswordUser(email).then(function () {

      commit(types.USER_LOGIN_OUT);
      commit(types.USER_FORGETPASSWORD_STATUS, 'success');

      removeStorage('expire_time');
      removeStorage('access_token');
      removeStorage('username');
      removeStorage('type');
      removeStorage('id');
      removeStorage('parties');

      router.push('/');
    }).catch(function () {
      commit(types.USER_FORGETPASSWORD_STATUS, 'fail');
      console.log('系統錯誤');
    });
  },
  actionResetPassword: function actionResetPassword(_ref6, viewData) {
    var commit = _ref6.commit;
    var newpw = viewData.newpw,
        confirmpw = viewData.confirmpw,
        token = viewData.token,
        router = viewData.router;


    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].resetPasswordUser(newpw, confirmpw, token).then(function () {
      commit(types.USER_LOGIN_OUT);
      commit(types.USER_RESETPASSWORD_STATUS, 'success');

      removeStorage('expire_time');
      removeStorage('access_token');
      removeStorage('username');
      removeStorage('id');
      removeStorage('type');
      removeStorage('parties');

      router.push('/');
    }).catch(function (error) {
      var data = error.response.data;

      var message = data.message;


      commit(types.USER_RESETPASSWORD_STATUS, 'fail');
      commit(types.USER_RESETPASSWORD_MESSAGE, message);
    });
  },
  actionUpdatePassword: function actionUpdatePassword(_ref7, viewData) {
    var commit = _ref7.commit;
    var oldpw = viewData.oldpw,
        confirmpw = viewData.confirmpw,
        newpw = viewData.newpw,
        token = viewData.token;


    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].updatePasswordUser(oldpw, confirmpw, newpw, token).then(function () {
      commit(types.USER_LOGIN_OUT);
      commit(types.USER_UPDATEPASSWORD_STATUS, 'success');
    }).catch(function (error) {
      var data = error.response.data;

      var message = data.message;


      commit(types.USER_UPDATEPASSWORD_STATUS, 'fail');
      commit(types.USER_UPDATEPASSWORD_MESSAGE, message);
    });
  },
  actionCheckAccount: function actionCheckAccount(_ref8, viewData) {
    var commit = _ref8.commit;
    var router = viewData.router,
        verificationCode = viewData.verificationCode;


    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].checkAccount(verificationCode).then(function (res) {

      commit(types.USER_CHECK_ACCOUNT_STATUS, 'success');

      var _res$data$data2 = res.data.data,
          id = _res$data$data2.id,
          email = _res$data$data2.email,
          type = _res$data$data2.type,
          parties = _res$data$data2.parties,
          tokenInfo = _res$data$data2.token_info;
      var access_token = tokenInfo.access_token;


      setStorage('access_token', access_token);
      setStorage('expire_time', new Date().getTime());
      setStorage('username', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__help_index__["a" /* getEmailName */])(email));
      setStorage('id', id);
      setStorage('type', type);
      setStorage('parties', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(parties));

      commit(types.USER_LOGIN_IN);

      router.push('/');
    }).catch(function (error) {
      var data = error.response.data;

      var message = data.message;


      commit(types.USER_CHECK_ACCOUNT_STATUS, 'fail');
      commit(types.USER_CHECK_ACCOUNT_MESSAGE, message);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_STATUS_RESET, function (s) {
  s.userLoginError = false;
  s.forgetPasswordStatus = '';

  s.updatePasswordStatus = '';
  s.updatePasswordMsg = '';

  s.checkUserAccountStatus = '';
  s.checkUserAccountMsg = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_LOGIN_OUT, function (s) {

  removeStorage('expire_time');
  removeStorage('access_token');
  removeStorage('username');
  removeStorage('id');
  removeStorage('type');
  removeStorage('parties');

  s.userLoginStatus = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_LOGIN_IN, function (s) {
  s.userLoginStatus = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_LOGIN_IN_ERROR, function (s) {
  s.userLoginError = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_FORGETPASSWORD_STATUS, function (s, result) {
  s.forgetPasswordStatus = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_RESETPASSWORD_STATUS, function (s, result) {
  s.resetPasswordStatus = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_RESETPASSWORD_MESSAGE, function (s, msg) {
  s.resetPasswordMsg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_UPDATEPASSWORD_STATUS, function (s, result) {
  s.updatePasswordStatus = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_UPDATEPASSWORD_MESSAGE, function (s, msg) {
  s.updatePasswordMsg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_CHECK_ACCOUNT_STATUS, function (s, result) {
  s.checkUserAccountStatus = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.USER_CHECK_ACCOUNT_MESSAGE, function (s, msg) {
  s.checkUserAccountMsg = msg;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_video__ = __webpack_require__(69);


var _mutations;



var num = 1;

var types = {
  GET_VIEW_VIDEO_LIST: 'videoService/getViewVideoList',
  GET_VIEW_VIDEO_LIST_TOTAL_PAGES: 'videoService/getViewVideoListTotalPages',

  GET_NEW_SLIDE_VIDEO_LIST: 'videoService/getNewSlideVideoList',
  GET_VIEW_SLIDE_VIDEO_LIST: 'videoService/getViewSlideVideoList',

  GET_VIDEO_TOTAL_PAGES: 'videoService/getVideoTotalPages',
  GET_PAGES_VIDEO_LIST: 'videoService/getPagesVideoList',
  GET_PAGES_SORT_VIDEO_LIST: 'videoService/getPagesSortVideoList',
  GET_BANNER_VIDEO_LIST: 'videoService/getBannerVideoList',
  GET_VIDEO_LIST: 'videoService/getVideoList',
  GET_MORE_VIDEO_LIST: 'videoService/getVideoMoreList',

  GET_ADVERTISERS_LIST: 'videoService/getAdvertisersList',
  GET_ADVERTISERS_VIDEO: 'videoService/getAdvertisersVideo'
};

var state = {
  videoViewList: [],
  videoViewTotalPages: 0,

  videoNewSlideList: [],
  videoViewSlideList: [],

  videoTotalPages: 0,

  videoList: [],
  videoPagesList: [],
  videoBannerList: [],

  advertisersVideoList: [],
  advertiserName: null,
  advertisersVideo: {}
};

var getters = {
  getViewVideoList: function getViewVideoList(s) {
    return s.videoViewList;
  },
  getViewVideoListTotalPages: function getViewVideoListTotalPages(s) {
    return s.videoViewTotalPages;
  },

  getNewSlideVideoList: function getNewSlideVideoList(s) {
    return s.videoNewSlideList;
  },
  getViewSlideVideoList: function getViewSlideVideoList(s) {
    return s.videoViewSlideList;
  },

  getVideoTotalPages: function getVideoTotalPages(s) {
    return s.videoTotalPages;
  },
  getPageVideoList: function getPageVideoList(s) {
    return s.videoPagesList;
  },
  getBannerVideoList: function getBannerVideoList(s) {
    return s.videoBannerList;
  },

  getVideoList: function getVideoList(s) {
    return s.videoList;
  },

  getAdvertisersVideoList: function getAdvertisersVideoList(s) {
    return s.advertisersVideoList;
  },
  getAdvertiserName: function getAdvertiserName(s) {
    return s.advertiserName;
  },
  getAdvertisersVideo: function getAdvertisersVideo(s) {
    return s.advertisersVideo;
  },

  getLoading: function getLoading(s) {
    return s.loading;
  }
};

var actions = {
  actionViewVideosList: function actionViewVideosList(_ref, pageNum) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getVideoViewList(pageNum).then(function (res) {
      var data = res.data,
          total_pages = res.total_pages;


      commit(types.GET_VIEW_VIDEO_LIST, data);
      commit(types.GET_VIEW_VIDEO_LIST_TOTAL_PAGES, total_pages);
    }).catch(function () {});
  },
  actionViewSlideVideosList: function actionViewSlideVideosList(_ref2) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getViewSlideVideoList().then(function (res) {
      var data = res.data;


      commit(types.GET_VIEW_SLIDE_VIDEO_LIST, data);
    }).catch(function () {});
  },
  actionNewSlideVideosList: function actionNewSlideVideosList(_ref3) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getNewSlideVideoList().then(function (res) {
      var data = res.data;


      commit(types.GET_NEW_SLIDE_VIDEO_LIST, data);
    }).catch(function () {});
  },
  actionBannerVideosList: function actionBannerVideosList(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getBannerVideoList().then(function (res) {
      var _data = res._data;


      commit(types.GET_BANNER_VIDEO_LIST, _data);
    }).catch(function () {});
  },
  actionGetVideoList: function actionGetVideoList(_ref5) {
    var commit = _ref5.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getVideoList().then(function (res) {
      var _data = res._data;


      commit(types.GET_VIDEO_LIST, _data);
    }).catch(function () {});
  },
  actionGetMoreVideoListUsePage: function actionGetMoreVideoListUsePage(_ref6, pageId) {
    var commit = _ref6.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getMoreVideoList(pageId).then(function (res) {
      var data = res.data,
          total_pages = res.total_pages;


      commit(types.GET_PAGES_VIDEO_LIST, data);
      commit(types.GET_VIDEO_TOTAL_PAGES, total_pages);
    }).catch(function () {});
  },
  actionGetMoreVideoList: function actionGetMoreVideoList(_ref7, loading) {
    var commit = _ref7.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getMoreVideoList(num).then(function (res) {
      var _data = res._data,
          _nextPage = res._nextPage;


      if (_nextPage !== null) {
        commit(types.GET_MORE_VIDEO_LIST, _data);
        num += 1;
        loading.$emit('$InfiniteLoading:loaded');
      } else {
        loading.$emit('$InfiniteLoading:complete');
      }
    }).catch(function () {});
  },
  actionGetAdvertisersList: function actionGetAdvertisersList(_ref8, advertiserId) {
    var commit = _ref8.commit;


    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getAdvertisersList(advertiserId).then(function (res) {
      var _data = res._data;


      var advertiserName = _data[0].client.name;

      var options = {
        result: _data,
        advertiserName: advertiserName
      };

      commit(types.GET_ADVERTISERS_LIST, options);
    }).catch(function () {});
  },
  actionGetAdvertisersVideo: function actionGetAdvertisersVideo(_ref9, params) {
    var commit = _ref9.commit;
    var advertiser_id = params.advertiser_id,
        id = params.id;


    __WEBPACK_IMPORTED_MODULE_1__services_video__["a" /* default */].getAdvertisersVideo(advertiser_id, id).then(function (res) {
      var _data = res._data;


      commit(types.GET_ADVERTISERS_VIDEO, _data);
    }).catch(function () {});
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_VIEW_VIDEO_LIST, function (s, p) {
  s.videoViewList = p;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_VIEW_VIDEO_LIST_TOTAL_PAGES, function (s, p) {
  s.videoViewTotalPages = p;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_NEW_SLIDE_VIDEO_LIST, function (s, p) {
  s.videoNewSlideList = p;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_VIEW_SLIDE_VIDEO_LIST, function (s, p) {
  s.videoViewSlideList = p;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_VIDEO_TOTAL_PAGES, function (s, p) {
  s.videoTotalPages = p;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_BANNER_VIDEO_LIST, function (s, d) {

  var bannerList = d;
  var newBannerList = [];

  bannerList.forEach(function (banner) {
    newBannerList.push({
      url: banner.slider_url ? banner.slider_url : banner.thumbnail_url,
      href: location.href + 'advertisers/' + banner.client.id + '/videos/' + banner.video_id,
      name: banner.video_name,
      showDescription: banner.description,
      word: banner.description,
      client: banner.client.name === null ? '' : banner.client.name,
      category: banner.category.name === null ? '' : banner.category.name
    });
  });

  s.videoBannerList = newBannerList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_PAGES_VIDEO_LIST, function (s, d) {
  s.videoPagesList = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_PAGES_SORT_VIDEO_LIST, function (s, type) {

  switch (type) {
    case 'new':
      s.videoPagesList = s.videoPagesList.sort(function (a, b) {
        return new Date(b.start_date) - new Date(a.start_date);
      });
      break;
    case 'impression':
      s.videoPagesList = s.videoPagesList.sort(function (a, b) {
        return b.view_count + b.youtube_view_count - (a.view_count + a.youtube_view_count);
      });
      break;
    default:
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_VIDEO_LIST, function (s, d) {
  s.videoList = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_MORE_VIDEO_LIST, function (s, d) {
  s.videoList = s.videoList.concat(d);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_ADVERTISERS_VIDEO, function (s, d) {
  s.advertisersVideo = d;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, types.GET_ADVERTISERS_LIST, function (s, options) {
  s.advertisersVideoList = options.result;
  s.advertiserName = options.advertiserName;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_type__ = __webpack_require__(23);


var _mutations;



var state = {
  isShowMobileMenu: false,
  pageLoadingStatus: false,
  isShowPopup: false,
  isPopupType: ''
};

var getters = {
  getPopupType: function getPopupType(s) {
    return s.isPopupType;
  },
  getPopupStatus: function getPopupStatus(s) {
    return s.isShowPopup;
  },
  mobileMenuStatus: function mobileMenuStatus(s) {
    return s.isShowMobileMenu;
  },
  rootState: function rootState(s) {
    return s;
  },
  pageLoadingStatus: function pageLoadingStatus(s) {
    return s.pageLoadingStatus;
  }
};

var actions = {
  changePopupType: function changePopupType(_ref, type) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["d" /* popupType */], type);
  },
  toggleMobileMenuStatus: function toggleMobileMenuStatus(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["e" /* toggleMobileMenu */]);
  },
  togglePopupStatus: function togglePopupStatus(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["c" /* togglePopup */]);
  },
  showLoading: function showLoading(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["a" /* loadingStatusShow */]);
  },
  hideLoading: function hideLoading(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["b" /* loadingStatusHide */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["d" /* popupType */], function (s, type) {
  s.isPopupType = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["c" /* togglePopup */], function (s) {
  s.isShowPopup = !s.isShowPopup;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["e" /* toggleMobileMenu */], function (s) {
  s.isShowMobileMenu = !s.isShowMobileMenu;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["a" /* loadingStatusShow */], function (s) {
  s.pageLoadingStatus = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["b" /* loadingStatusHide */], function (s) {
  s.pageLoadingStatus = false;
}), _mutations);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_Login__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Forgetpassword__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_Forgetpassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login_Forgetpassword__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_2__components_login_Login___default.a,
    ForgetPassword: __WEBPACK_IMPORTED_MODULE_3__components_login_Forgetpassword___default.a
  },
  created: function created() {
    if (localStorage.getItem('access_token')) {
      this.actionUserLoginIn();
    } else {
      this.actionUserLoginOut();
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: 'OneBrandMaster 品牌廣告戰情室',
      meta: [{ name: 'og:title', content: 'OneBrandMaster 品牌廣告戰情室' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    popuptype: 'getPopupType',
    popupStatus: 'getPopupStatus',
    pageLoadingStatus: 'pageLoadingStatus',
    userStatus: 'getUserLoginStatus'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['resetUserStatus', 'actionUserLoginIn', 'actionUserLoginOut', 'togglePopupStatus', 'changePopupType']), {
    closePopup: function closePopup() {
      this.togglePopupStatus();
      this.changePopupType('');
      this.resetUserStatus();
    }
  })
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {



/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user_forget_password',
  data: function data() {
    return {
      comfirm: false,
      email: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    fgStatus: 'getForgetpasswordStatus'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['actionForgetPassword']), {
    submitEmail: function submitEmail() {
      if (this.email.length > 0) {
        var viewData = {
          email: this.email,
          router: this.$router
        };

        this.comfirm = false;
        this.actionForgetPassword(viewData);
        return;
      }

      this.comfirm = true;
    }
  })
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_logo__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_logo__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user_login',
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_2__common_logo___default.a
  },
  data: function data() {
    return {
      email: 'Hello@onead.com.tw',
      comfirm: false,
      account: '',
      password: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    userStatus: 'getUserLoginStatus',
    userLoginError: 'getUserLoginError'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['actionLoginIn', 'changePopupType']), {
    submitLogin: function submitLogin() {
      if (this.account.length > 0 && this.password.length > 0) {

        var userData = {
          email: this.account,
          password: this.password,
          router: this.$router
        };

        this.comfirm = false;
        this.actionLoginIn(userData);
        return;
      }

      this.comfirm = true;
    },
    goForgetPassword: function goForgetPassword() {
      this.changePopupType('fg');
    }
  })
});

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(136),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(137),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "popup",
      "tag": "div"
    }
  }, [(_vm.popupStatus) ? _c('div', {
    key: _vm.popupStatus,
    staticClass: "popup-model"
  }, [_c('div', {
    staticClass: "popup-bg",
    on: {
      "click": _vm.closePopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-header"
  }, [_vm._v("\n            " + _vm._s(_vm.popuptype === 'login' ? '登入' : '忘記密碼') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pop-content"
  }, [(_vm.popuptype === 'login') ? _c('Login') : _vm._e(), _vm._v(" "), (_vm.popuptype === 'fg') ? _c('ForgetPassword') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pop-close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")])])]) : _vm._e()]), _vm._v(" "), (_vm.pageLoadingStatus) ? _c('div', {
    staticClass: "loading",
    class: {
      'isShow': _vm.pageLoadingStatus === true
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._v(" OneAD © " + _vm._s(new Date().getFullYear()) + ". All rights reserved ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner_double"
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2"
  })])
}]}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 391.3 38.3"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 391.3 38.3",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M18.4,4.4c2.9,0,5.7,0.7,8.2,2.2c2.5,1.5,4.6,3.5,6.1,6c1.5,2.5,2.2,5.2,2.2,8.1s-0.8,5.6-2.2,8.1\n    c-1.5,2.5-3.5,4.5-6.1,6C24,36.3,21.3,37,18.4,37c-2.9,0-5.7-0.7-8.2-2.2c-2.5-1.5-4.6-3.5-6.1-6c-1.5-2.5-2.2-5.2-2.2-8.1\n    c0-2.2,0.4-4.3,1.3-6.3c0.9-2,2.1-3.7,3.6-5.3c1.5-1.5,3.3-2.7,5.3-3.5C14.1,4.8,16.2,4.4,18.4,4.4z M18.4,6.3\n    c-2.6,0-5,0.7-7.2,2c-2.2,1.3-4,3.1-5.3,5.3c-1.3,2.2-2,4.6-2,7.2s0.7,5,2,7.2c1.3,2.2,3.1,4,5.3,5.3c2.2,1.3,4.6,2,7.2,2\n    c2.6,0,5-0.7,7.2-2c2.2-1.3,4-3.1,5.3-5.3c1.3-2.2,2-4.6,2-7.2c0-1.9-0.4-3.8-1.1-5.5c-0.8-1.8-1.8-3.3-3.1-4.6s-2.9-2.4-4.6-3.1\n    C22.1,6.7,20.3,6.3,18.4,6.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M41.5,17.1v3h0.1c0.6-1.1,1.4-1.9,2.4-2.5c1-0.6,2.1-0.9,3.4-0.9c1.6,0,2.9,0.3,3.9,1c0.9,0.6,1.6,1.6,2,2.7\n    c0.4,1.2,0.6,2.7,0.6,4.4v11.8h-1.9V24.8c0-1.4-0.1-2.5-0.3-3.4c-0.2-0.9-0.7-1.6-1.3-2.2c-0.7-0.5-1.7-0.8-3-0.8\n    c-1.5,0-2.7,0.4-3.5,1.2c-0.8,0.8-1.4,1.8-1.7,3.1c-0.3,1.3-0.4,2.7-0.4,4.2v9.6h-1.9V17.1H41.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M77.2,27H60.3c0,1.6,0.3,3.1,1,4.3c0.7,1.2,1.6,2.2,2.8,2.9c1.2,0.7,2.5,1,4,1c1.5,0,2.8-0.4,4-1.2\n    c1.2-0.8,2.1-1.9,2.9-3.2l1.6,0.9c-0.9,1.7-2.1,3-3.6,3.9S69.8,37,67.8,37c-1.9,0-3.5-0.5-5-1.4c-1.4-0.9-2.5-2.2-3.3-3.7\n    c-0.8-1.6-1.2-3.3-1.2-5.1c0-1.8,0.4-3.5,1.2-5.1c0.8-1.5,1.9-2.8,3.3-3.7s3.1-1.4,4.9-1.4c1.9,0,3.6,0.5,5,1.4\n    c1.4,0.9,2.5,2.2,3.3,3.8C76.8,23.4,77.2,25.2,77.2,27z M60.3,25.3h15c-0.2-1.2-0.6-2.3-1.2-3.4c-0.7-1-1.6-1.9-2.6-2.5\n    c-1.1-0.6-2.3-0.9-3.5-0.9s-2.5,0.3-3.6,0.9c-1.1,0.6-2,1.4-2.7,2.5C60.8,22.9,60.4,24.1,60.3,25.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M90.1,36.6H82V4.8h6.4c1.5,0,2.7,0.1,3.7,0.4c1,0.2,2,0.7,2.8,1.5c1.8,1.5,2.7,3.7,2.7,6.6\n    c0,2.9-1.2,5.1-3.7,6.5c1.3,0.3,2.4,0.8,3.4,1.5c1,0.8,1.8,1.7,2.3,2.8c0.5,1.1,0.8,2.3,0.8,3.7c0,2.7-1,4.9-3,6.6\n    c-1,0.9-2.1,1.5-3.3,1.8C93.1,36.5,91.7,36.6,90.1,36.6z M84,6.7v12.5h3.5h1c1,0,1.9-0.1,2.6-0.2c0.7-0.1,1.4-0.5,2.1-1\n    c0.9-0.6,1.5-1.4,1.8-2.2c0.3-0.8,0.5-1.8,0.5-2.9c0-1.1-0.2-2.1-0.6-3c-0.4-0.9-1.1-1.7-2-2.2c-0.7-0.5-1.5-0.7-2.3-0.8\n    c-0.8-0.1-1.9-0.2-3.1-0.2H84z M84,21.1v13.6h4.8c1.5,0,2.8-0.1,3.7-0.2c1-0.1,1.9-0.5,2.8-1c2.1-1.4,3.1-3.3,3.1-5.7\n    c0-1.2-0.3-2.3-0.9-3.4c-0.6-1-1.4-1.8-2.4-2.3c-1.4-0.7-3.6-1-6.7-1H84z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M107.5,17.1v2.5h0.1c0.8-2,2.3-2.9,4.2-2.9c0.7,0,1.4,0.2,2.1,0.5l-1,1.7c-0.5-0.3-0.9-0.4-1.3-0.4\n    c-1.2,0-2,0.4-2.6,1.1c-0.6,0.7-1,1.6-1.1,2.6c-0.2,1-0.2,2.2-0.2,3.5v1v10h-1.9V17.1H107.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M134.5,17.1v19.5h-1.9v-3.5h-0.1c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1v-3.4H134.5z M124.9,18.5c-1.1,0-2.1,0.2-3,0.7\n    c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1\n    s2.5,1.2,4,1.2c1.6,0,3-0.4,4.1-1.2c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1\n    c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7C127.1,18.7,126.1,18.5,124.9,18.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M142.9,17.1v3h0.1c0.6-1.1,1.4-1.9,2.4-2.5s2.1-0.9,3.4-0.9c1.6,0,2.9,0.3,3.9,1c0.9,0.6,1.6,1.6,2,2.7\n    c0.4,1.2,0.6,2.7,0.6,4.4v11.8h-1.9V24.8c0-1.4-0.1-2.5-0.3-3.4c-0.2-0.9-0.7-1.6-1.3-2.2c-0.7-0.5-1.7-0.8-3-0.8\n    c-1.5,0-2.7,0.4-3.5,1.2c-0.8,0.8-1.4,1.8-1.7,3.1c-0.3,1.3-0.4,2.7-0.4,4.2v9.6H141V17.1H142.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M176.9,36.6v-3.5h-0.1c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1V1.8h1.9v34.8H176.9z M169.3,35.3c1.6,0,3-0.4,4.1-1.2\n    c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7\n    c-1-0.4-2-0.6-3.2-0.6c-1.1,0-2.1,0.2-3,0.7c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1\n    c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1S167.8,35.3,169.3,35.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M218.4,36.6L213,10.3h-0.1l-11.1,27.4l-11-27.4h-0.1l-5.4,26.3h-1.9l6.8-32.9l11.7,28.9l11.7-28.9l6.8,32.9\n    H218.4z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M242,17.1v19.5h-1.9v-3.5H240c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1v-3.4H242z M232.4,18.5c-1.1,0-2.1,0.2-3,0.7\n    c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1\n    s2.5,1.2,4,1.2c1.6,0,3-0.4,4.1-1.2c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1\n    c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7C234.7,18.7,233.6,18.5,232.4,18.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M258.3,19.8l-1.6,0.8c-0.3-0.7-0.8-1.2-1.4-1.6c-0.6-0.4-1.3-0.6-2-0.6c-0.8,0-1.6,0.3-2.3,0.9\n    c-0.7,0.6-1,1.3-1,2.1c0,1,0.3,1.7,1,2.2c0.7,0.4,1.8,0.9,3.5,1.6c1.7,0.6,2.9,1.3,3.7,2.1c0.8,0.8,1.3,2,1.3,3.6\n    c0,1.2-0.3,2.2-0.8,3.1c-0.6,0.9-1.3,1.7-2.3,2.2c-1,0.5-2,0.8-3.2,0.8c-1.6,0-3.1-0.5-4.3-1.4c-1.2-0.9-2-2.2-2.4-3.8l1.9-0.6\n    c0.8,2.6,2.4,4,4.9,4c1.2,0,2.3-0.4,3.1-1.3c0.8-0.9,1.3-1.9,1.3-3.1c0-1.1-0.3-1.9-1-2.4c-0.6-0.5-1.6-1-2.8-1.4\n    c-1.2-0.4-2.1-0.8-2.9-1.2c-0.8-0.4-1.4-0.9-2-1.6c-0.5-0.7-0.8-1.5-0.8-2.5c0-1.4,0.5-2.6,1.6-3.5c1-0.9,2.3-1.4,3.7-1.4\n    c0.7,0,1.3,0.1,2,0.4c0.7,0.3,1.3,0.6,1.8,1.1C257.7,18.7,258.1,19.2,258.3,19.8z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M266.4,18.9v17.7h-1.9V18.9h-2.2v-1.8h2.2v-7h1.9v7h3.4v1.8H266.4z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M290,27h-16.9c0,1.6,0.3,3.1,1,4.3c0.7,1.2,1.6,2.2,2.8,2.9c1.2,0.7,2.5,1,4,1c1.5,0,2.8-0.4,4-1.2\n    s2.1-1.9,2.9-3.2l1.6,0.9c-0.9,1.7-2.1,3-3.6,3.9s-3.2,1.4-5.1,1.4c-1.9,0-3.5-0.5-5-1.4c-1.4-0.9-2.5-2.2-3.3-3.7\n    c-0.8-1.6-1.2-3.3-1.2-5.1c0-1.8,0.4-3.5,1.2-5.1c0.8-1.5,1.9-2.8,3.3-3.7c1.4-0.9,3.1-1.4,4.9-1.4c1.9,0,3.6,0.5,5,1.4\n    c1.4,0.9,2.5,2.2,3.3,3.8C289.7,23.4,290,25.2,290,27z M273.1,25.3h15c-0.2-1.2-0.6-2.3-1.2-3.4c-0.7-1-1.6-1.9-2.6-2.5\n    c-1.1-0.6-2.3-0.9-3.5-0.9c-1.3,0-2.5,0.3-3.6,0.9c-1.1,0.6-2,1.4-2.7,2.5C273.6,22.9,273.2,24.1,273.1,25.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M296.5,17.1v2.5h0.1c0.8-2,2.3-2.9,4.2-2.9c0.7,0,1.4,0.2,2.1,0.5l-1,1.7c-0.5-0.3-0.9-0.4-1.3-0.4\n    c-1.2,0-2,0.4-2.6,1.1c-0.6,0.7-1,1.6-1.1,2.6c-0.2,1-0.2,2.2-0.2,3.5v1v10h-1.9V17.1H296.5z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st3",
    attrs: {
      "points": "12.3,10.2 21.4,15.4 30.6,20.6 21.5,25.9 12.4,31.3 12.3,20.7"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "st3",
    attrs: {
      "x1": "12.3",
      "y1": "13.6",
      "x2": "27.4",
      "y2": "22.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st4",
    attrs: {
      "points": "353.2,36 353.2,26.8 363.3,26.8 363.3,28.4 355.3,28.4 355.3,30.4 363.3,30.4 363.3,32 355.3,32 355.3,34.3 363.3,34.3 363.3,36"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st4",
    attrs: {
      "points": "349.2,33 349.2,26.8 351.3,26.8 351.3,36 349.7,36 342.2,29.7 342.2,36 340.1,36 340.1,26.8 341.7,26.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M375.2,36l-1.2-2.2h-5.6l-1.2,2.2h-2.1l5.1-9.3h1.9l5.1,9.3H375.2z M371.2,28.6l-2.1,3.8h4.2L371.2,28.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M378.9,36v-9.1h7.7c0.6,0,1,0,1.4,0.1c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.5,0.9\n    c0.1,0.4,0.1,0.8,0.1,1.4V33c0,0.6,0,1-0.1,1.4c-0.1,0.4-0.2,0.7-0.5,0.9c-0.2,0.2-0.5,0.4-0.9,0.5c-0.4,0.1-0.8,0.1-1.4,0.1\n    H378.9z M387.7,29.8c0-0.5-0.1-0.8-0.2-0.9c-0.2-0.2-0.4-0.2-0.8-0.2h-5.9v5.5h5.9c0.4,0,0.7-0.1,0.8-0.2\n    c0.2-0.2,0.2-0.5,0.2-0.9V29.8z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st4",
    attrs: {
      "d": "M326.3,28.8c0-0.9,0.2-1.5,0.5-1.9c0.3-0.3,1-0.5,1.9-0.5h7.2c0.9,0,1.6,0.2,1.9,0.5\n    c0.3,0.3,0.5,0.9,0.5,1.9V34c0,0.9-0.2,1.5-0.5,1.9c-0.3,0.3-1,0.5-1.9,0.5h-7.2c-0.9,0-1.6-0.2-1.9-0.5\n    c-0.3-0.3-0.5-0.9-0.5-1.9V28.8z M328.5,34.5h7.6v-6.3h-7.6V34.5z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st5",
    attrs: {
      "points": "331.1,31.4 331.1,29.6 332.6,30.5 334.2,31.4 332.6,32.3 331.1,33.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M331.1,33.5c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.3v-3.6c0-0.1,0.1-0.2,0.2-0.3\n    c0.1-0.1,0.2-0.1,0.3,0l3.1,1.8c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.3l-3.1,1.8C331.2,33.5,331.1,33.5,331.1,33.5\n      M331.4,30.2v2.5l2.1-1.2L331.4,30.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M309.2,35.8h-1.1v-9.3h1.1v3.3c0.5-0.6,1.1-0.9,1.8-0.9c0.4,0,0.8,0.1,1.2,0.3s0.7,0.4,0.9,0.7\n    s0.4,0.7,0.6,1.1c0.1,0.4,0.2,0.9,0.2,1.4c0,1.2-0.3,2-0.9,2.7c-0.6,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.4-0.3-1.9-1V35.8z\n      M309.2,32.3c0,0.8,0.1,1.4,0.3,1.8c0.4,0.6,0.8,0.9,1.5,0.9c0.5,0,0.9-0.2,1.3-0.7c0.4-0.4,0.5-1.1,0.5-1.9\n    c0-0.9-0.2-1.5-0.5-1.9c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-0.9,0.2-1.3,0.7C309.4,30.9,309.2,31.5,309.2,32.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M315.3,38.4l-0.1-1.1c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.6-0.1s0.3-0.2,0.4-0.4\n    c0.1-0.1,0.2-0.4,0.3-0.9c0-0.1,0.1-0.2,0.1-0.3l-2.6-6.8h1.2l1.4,3.9c0.2,0.5,0.3,1,0.5,1.6c0.1-0.5,0.3-1,0.5-1.5l1.4-3.9h1.1\n    l-2.6,6.9c-0.3,0.7-0.5,1.3-0.6,1.5c-0.2,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.6,0.3-0.9,0.3C315.8,38.5,315.6,38.4,315.3,38.4z"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_forgetpassword"
  }, [(!_vm.fgStatus) ? _c('form', {
    staticClass: "form-forgetpassword"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "請輸入當初註冊的信箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.comfirm) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("信箱格式錯誤")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-submit",
    on: {
      "click": _vm.submitEmail
    }
  }, [_vm._v("送出")])]) : _vm._e(), _vm._v(" "), (_vm.fgStatus === 'success') ? _c('div', {
    staticClass: "submit-success"
  }, [_c('h3', [_vm._v("密碼已寄送到 " + _vm._s(_vm.email))]), _vm._v(" "), _c('p', [_vm._v("已寄發重設密碼連結信件到信箱，請盡快打開信件進行後續設定！")])]) : _vm._e(), _vm._v(" "), (_vm.fgStatus === 'fail') ? _c('div', {
    staticClass: "submit-fail"
  }, [_c('p', [_vm._v("網頁錯誤，請重新整理再試一次。")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('form', {
    staticClass: "form-signin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text",
      "name": "account",
      "placeholder": "請輸入帳號"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "請輸入密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.comfirm) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("帳號或密碼未輸入")]) : _vm._e(), _vm._v(" "), (_vm.userLoginError) ? _c('div', {
    staticClass: "warning"
  }, [_vm._v("帳號或密碼錯誤")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-submit",
    on: {
      "click": _vm.submitLogin
    }
  }, [_vm._v("送出")]), _vm._v(" "), _c('div', {
    staticClass: "form-signin__fg_pw",
    on: {
      "click": _vm.goForgetPassword
    }
  }, [_vm._v("忘記密碼")])]), _vm._v(" "), _c('div', {
    staticClass: "login-desc"
  }, [_c('p', [_vm._v("登入功能僅限 OneBrandMaster 合作夥伴使用，")]), _vm._v(" "), _c('p', [_vm._v("如有登入需求，請與"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": ("mailto:" + _vm.email)
    }
  }, [_vm._v("我們聯繫！")])])])])
},staticRenderFns: []}

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(12);

/***/ })
],[62]);


// WEBPACK FOOTER //
// static/js/app.bf1aa400ad40cd16f177.js